import { Report1917Container } from "../../../containers/borrowSystem/Report/Report1917Container";

export function Report1917Page() {
    return (
        <Report1917Container />
    )
}